import * as React from 'react';
import { InfoMessageTypeEnum } from '@websky/graphql';
import { ThemeProvider } from '../../theme';
import BaseNotification from '../../BaseComponents/Notification';
const STATUS_MAP = {
    [InfoMessageTypeEnum.Warning]: 'error',
    [InfoMessageTypeEnum.Promo]: 'note',
    [InfoMessageTypeEnum.Info]: 'warning',
    [InfoMessageTypeEnum.SubscriptionSaving]: 'subscription',
    [InfoMessageTypeEnum.HtmlContent]: 'note'
};
/**
 * @deprecated - use BaseComponents/Notification
 */
const Notification = ({ className, iconClassName, contentClassName, titleClassName, textClassName, contextClassName, globalClassName, htmlClassName, title, image, icon, status, type, infoMessage, actionClassName, actionText, actionVariant = 'optionEdit', onClickAction, actionLoading, renderMessagesWithoutWrapper, hideIcon }) => {
    var _a;
    if (renderMessagesWithoutWrapper) {
        return React.createElement("div", { className: htmlClassName, dangerouslySetInnerHTML: { __html: infoMessage.text } });
    }
    const classNames = React.useMemo(() => {
        return {
            BaseComponents: {
                Notification: {
                    icon: iconClassName,
                    content: contentClassName,
                    title: titleClassName,
                    text: textClassName,
                    context: contextClassName,
                    global: globalClassName,
                    action: actionClassName
                }
            }
        };
    }, [
        iconClassName,
        contentClassName,
        titleClassName,
        textClassName,
        contextClassName,
        globalClassName,
        actionClassName
    ]);
    return (React.createElement(ThemeProvider, { value: classNames },
        React.createElement(BaseNotification, { type: type, className: className, code: infoMessage.code, title: title !== null && title !== void 0 ? title : infoMessage.title, icon: icon, actionText: actionText, actionLoading: actionLoading, onClickAction: onClickAction, image: image, text: infoMessage.text, actionVariant: actionVariant, hideIcon: hideIcon, asHtml: infoMessage.type === InfoMessageTypeEnum.HtmlContent, status: (_a = STATUS_MAP[status !== null && status !== void 0 ? status : infoMessage.type]) !== null && _a !== void 0 ? _a : 'done' })));
};
export default Notification;
